export default __webpack_public_path__ + "static/1211-23d54c6b4fc04de3289f4396c3d72e78.gif";